import {
    Box,
    Link,
    Text,
    ThemeColorVariable,
    ThemeFontSizeVariable,
    ThemeSpaceVariable,
} from "@caspeco/casper-ui-library";
import { useExternalBookingSettings } from "api/api-hooks/use-external-booking-settings";
import React from "react";
import { Trans } from "react-i18next";
import { ensureHttpPrefix } from "utils/url-utils";

interface IPrivacyPolicyTextProps {
    onOpen: () => void;
}

const PrivacyPolicyText = ({ onOpen }: IPrivacyPolicyTextProps) => {
    const { data: settings } = useExternalBookingSettings();
    const handlePolicyClicked = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        onOpen();
    };
    const tocText = settings?.externalBookingToc;
    const tocUrl = ensureHttpPrefix(tocText);

    return (
        <Text
            mb={ThemeSpaceVariable.Medium}
            color={ThemeColorVariable.OnSurfaceSubdued}
            fontSize={ThemeFontSizeVariable.Small}
        >
            <Trans
                i18nKey={tocText ? "privacyPolicyWithToC" : "privacyPolicyLink"}
                components={{
                    1: (
                        <Box
                            as="button"
                            color={ThemeColorVariable.OnSurfaceSubdued}
                            textDecoration="underline"
                            onClick={handlePolicyClicked}
                        />
                    ),
                    2: (
                        <Link
                            color={ThemeColorVariable.OnSurfaceSubdued}
                            href={tocUrl}
                            target="_blank"
                        />
                    ),
                }}
            />
        </Text>
    );
};

export default PrivacyPolicyText;
